import React , {useEffect} from 'react';
import { translate } from 'react-i18next';
import { connect } from "react-redux";
import { compose } from "redux";
import { Button, Col, Row } from "antd";
import InfiniteScrollTable from '../../../components/infinite-scroll-table';
import Call from "../../../hocs/call";
import { GUTTER_MD } from "../../../styles/constants";
import { superUserMenu, userMenu } from "../../../constants/menus";
import { changeSetPermissionsConnections, readSetPermissionsConnections } from "./actions";


const mapStateToProps = state => ({
  permissions: state.scenes.manageUsers.setPermissions.permissions,
  functionalities: state.scenes.manageUsers.setPermissions.functionalities,
  connections: state.scenes.manageUsers.setPermissions.connections
});

const mapDispatchToProps = dispatch => ({
  onChange: connectionPermissions =>
    dispatch(changeSetPermissionsConnections(connectionPermissions)),
  fetchConnections: menu => dispatch(readSetPermissionsConnections(menu))
});


const SetPermissionsConnections = ({
  t,
  permissions,
  onChange,
  fetchConnections,
  connections
}) => {


  useEffect(() => {
    fetchConnections([...userMenu(t), ...superUserMenu(t)]);
  }, [fetchConnections, t]);

  const allConnections = (connections || []).map(conn => conn.entityId);
  return (
    <Call cb={fetchConnections} cbParam={[...userMenu(t), ...superUserMenu(t)]}>
      <div className="set-permissions__functionalities__tree">
        {connections && (
          <InfiniteScrollTable
            showHeader={false}
            height={284}
            data={
              connections.map(connection => {
                const id = connection.entityId;
                const name = connection.connectionName;
                return ({
                  id: id,
                  label: name
                })
              })
            }
            
            getRowKey={({id}) => id}
            columns={[
              {
                dataIndex: 'label',
                minWidht: 150,
              }
            ]}
            rowSelection={{
              selectedRowKeys: permissions ? permissions.dbbConnections : [],
              onChange
            }}
            rightActions={
              <Row type="flex" gutter={GUTTER_MD}>
                <Col>
                  <Button onClick={() => onChange(allConnections)} type="primary">
                    {t('commons.buttons.selectAll.title')}
                  </Button>
                </Col>
                <Col>
                  <Button onClick={() => onChange([])}>
                    {t('commons.buttons.deselectAll.title')}
                  </Button>
                </Col>
              </Row>
            }
          />
        )}
      </div>
    </Call>
  )
};




export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(SetPermissionsConnections);
